@switch (type()) {
  @case ('primary') {
    <button
      pButton
      [icon]="icon()"
      [label]="label()"
      [iconPos]="iconPos()"
      [severity]="severity()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
      [fluid]="fullWidth()"
      [ngClass]="{ borderless: borderless(), 'tar-btn': true, 'is-loading': loading(), 'padingless': padingless() }"
      [class]="styleClass() || ''"
      [ngStyle]="style()"
      [id]="id()"
      rounded
    >
      @if(loading()) {
        <span class="loading-overlay" aria-hidden="true">
          <p-progressSpinner strokeWidth="8" [style.width.px]="18" [style.height.px]="18"></p-progressSpinner>
          @if (loadLabel().length) {
            <span class="load-label">{{ loadLabel() }}</span>
          }
        </span>
      }
      @if (iconComponent()) {
        <ng-container *ngComponentOutlet="iconComponent()"></ng-container>
      }

      @if (suffixIcon()) {
        <i [ngClass]="suffixIcon()" style="order: 999;" aria-hidden="true"></i>
      }
    </button>
  }
  @case ('secondary') {
    <button
      pButton
      [icon]="icon()"
      [label]="label()"
      [iconPos]="iconPos()"
      [severity]="severity()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
      [fluid]="fullWidth()"
      [ngClass]="{ borderless: borderless(), 'tar-btn': true, 'is-loading': loading(), 'padingless': padingless() }"
      [class]="styleClass() || ''"
      [ngStyle]="style()"
      [id]="id()"
      outlined
      rounded
    >
      @if(loading()) {
        <span class="loading-overlay" aria-hidden="true">
          <p-progressSpinner strokeWidth="8" [style.width.px]="18" [style.height.px]="18"></p-progressSpinner>
          @if (loadLabel().length) {
            <span class="load-label">{{ loadLabel() }}</span>
          }
        </span>
      }
      @if (iconComponent()) {
        <ng-container *ngComponentOutlet="iconComponent()"></ng-container>
      }

      @if (suffixIcon()) {
        <i [ngClass]="suffixIcon()" style="order: 999;" aria-hidden="true"></i>
      }
    </button>
  }
  @case ('action') {
    <button
      pButton
      [icon]="icon()"
      [label]="label()"
      [iconPos]="iconPos()"
      [severity]="severity()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
      [fluid]="fullWidth()"
      [ngClass]="{ borderless: borderless(), 'tar-btn': true, 'is-loading': loading(), 'padingless': padingless() }"
      [class]="styleClass() || ''"
      [ngStyle]="style()"
      [size]="size()"
      [id]="id()"
      text
    >
      @if(loading()) {
        <span class="loading-overlay" aria-hidden="true">
          <p-progressSpinner strokeWidth="8" [style.width.px]="18" [style.height.px]="18"></p-progressSpinner>
          @if (loadLabel().length) {
            <span class="load-label">{{ loadLabel() }}</span>
          }
        </span>
      }
      @if (iconComponent()) {
        <ng-container *ngComponentOutlet="iconComponent()"></ng-container>
      }

      @if (suffixIcon()) {
        <i [ngClass]="suffixIcon()" style="order: 999;" aria-hidden="true"></i>
      }
    </button>
  }
}
